import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { DepartamentoSelect } from 'sharedComponents/select'

const IdDepartamentoFormGroup = ({ values, setValues, handleChange, iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='DEPARTAMENTO' htmlFor='select-idDepartamento' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idDepartamento'>
          {({ field }) => (
            <DepartamentoSelect
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-idDepartamento'
              onChange={e => {
                handleChange(e)
                values._idDepartamento = e.target.value
                values._idProvincia = ''
                values._idDistrito = ''
                setValues(values)
              }}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(IdDepartamentoFormGroup)
